import { Moon, Settings, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Switch } from "@/components/ui/switch";

export const SettingsPopover = ({ theme, setTheme, pageTurn, setPageTurn, showProgress, setShowProgress }) => {
  const dark = theme === "dark";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          data-testid="settings-btn"
          className="rounded-full transition-transform duration-300 hover:rotate-45"
          aria-label="Reading room settings"
        >
          <Settings className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72" data-testid="settings-panel">
        <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Reading room</p>
        <div className="mt-5 space-y-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm">
              {dark ? <Moon className="h-4 w-4 text-primary" /> : <Sun className="h-4 w-4 text-primary" />}
              <span>{dark ? "Night reading" : "E-ink paper"}</span>
            </div>
            <Switch
              data-testid="theme-toggle"
              checked={dark}
              onCheckedChange={(checked) => setTheme(checked ? "dark" : "light")}
              aria-label="Toggle dark and light theme"
            />
          </div>
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm">Page turn</span>
            <div className="flex gap-1 rounded-full border border-border p-1">
              <button
                data-testid="transition-flip-btn"
                onClick={() => setPageTurn("flip")}
                className={`rounded-full px-3 py-1 text-xs transition-colors duration-200 ${
                  pageTurn === "flip" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
                }`}
              >
                Flip
              </button>
              <button
                data-testid="transition-fade-btn"
                onClick={() => setPageTurn("fade")}
                className={`rounded-full px-3 py-1 text-xs transition-colors duration-200 ${
                  pageTurn === "fade" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
                }`}
              >
                Fade
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm">Progress bar</span>
            <Switch
              data-testid="progress-toggle"
              checked={showProgress}
              onCheckedChange={setShowProgress}
              aria-label="Toggle reading progress bar"
            />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
